module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_m_footer.a7be88b011ea950ca471fe4a52ab4098.svg";